import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import {
  AsyncDataItem,
  idleDataItem,
  isError,
  isLoading
} from '@pharvio/core/shared';
import { WidgetErrorComponent } from '../widget-error/widget-error.component';
import { ClickStopPropagationDirective } from '@pharvio/core/ui';

@Component({
  selector: 'app-list-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconModule,
    RouterLink,
    WidgetErrorComponent,
    ClickStopPropagationDirective
  ],
  templateUrl: './list-card.component.html'
})
export class ListCardComponent {
  @Input({ required: true }) title = '';
  @Input({ required: true }) icon = '';
  @Input({ required: true }) colorClass = '';
  @Input() item?: AsyncDataItem<any> = idleDataItem(null);
  @Input() count: number | null = null;
  @Input() link: string | null = null;
  @Output() retry = new EventEmitter<void>();

  protected readonly isLoading = isLoading;
  protected readonly isError = isError;
}
